import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de3a678e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex xl:hidden" }
const _hoisted_2 = { class: "w-full text-left text-sm text-dark-800" }
const _hoisted_3 = { class: "w-full text-right text-sm text-dark-800" }

import { Ref, ref } from 'vue';
import {
  BlackDesertItemDetails,
  BlackDesertItemDetailsAvailability,
  BlackDesertItemType,
} from '@blackdesertmarket/interfaces';
import { LoaderSize } from '@/enums/loader';
import { UseItemAvailabilityReturn, useItemAvailability } from '@/composables/item-details/use-item-availability';
import { UseItemDetailsFetchReturn, useItemDetailsFetch } from '@/composables/item-details/use-item-details-fetch';
import { UseItemTypeFetchReturn, useItemTypeFetch } from '@/composables/item-type/use-item-type-fetch';
import { TranslateKey, useInject } from '@/composables/use-inject';
import AppLoader from '@/components/Base/AppLoader/AppLoader.vue';
import ItemDetailsAdditional from '@/components/ItemDetails/ItemDetailsAdditional.vue';
import ItemDetailsAvailability from '@/components/ItemDetails/ItemDetailsAvailability.vue';
import ItemDetailsAvailabilityItem from '@/components/ItemDetails/ItemDetailsAvailabilityItem.vue';
import ItemDetailsOverview from '@/components/ItemDetails/ItemDetailsOverview/ItemDetailsOverview.vue';
import ItemDetailsTab from '@/components/ItemDetails/ItemDetailsTab.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemDetails',
  props: {
  id: {
    type: Number,
    required: true,
  },
  enhancement: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const translate = useInject(TranslateKey);
const itemListFetch: UseItemTypeFetchReturn = useItemTypeFetch(props.id);
const itemDetailsFetch: UseItemDetailsFetchReturn = useItemDetailsFetch(props.id, props.enhancement, true);

const itemType: Ref<BlackDesertItemType | null> = ref(null);
const itemDetails: Ref<BlackDesertItemDetails | null> = ref(null);
const activeTab: Ref<number> = ref(0);

const getOnePrice = (
  itemDetails: BlackDesertItemDetails,
  itemAvailability: BlackDesertItemDetailsAvailability,
): string => {
  const itemAvailabilityComposable: UseItemAvailabilityReturn = useItemAvailability(itemDetails, itemAvailability);
  return itemAvailabilityComposable.getOnePrice();
};

const getSellCount = (
  itemDetails: BlackDesertItemDetails,
  itemAvailability: BlackDesertItemDetailsAvailability,
): string => {
  const itemAvailabilityComposable: UseItemAvailabilityReturn = useItemAvailability(itemDetails, itemAvailability);
  return itemAvailabilityComposable.getSellCount();
};

const getBuyCount = (
  itemDetails: BlackDesertItemDetails,
  itemAvailability: BlackDesertItemDetailsAvailability,
): string => {
  const itemAvailabilityComposable: UseItemAvailabilityReturn = useItemAvailability(itemDetails, itemAvailability);
  return itemAvailabilityComposable.getBuyCount();
};

const getItemAvailabilityBackgroundClass = (
  itemDetails: BlackDesertItemDetails,
  itemAvailability: BlackDesertItemDetailsAvailability,
): string => {
  const itemAvailabilityComposable: UseItemAvailabilityReturn = useItemAvailability(itemDetails, itemAvailability);
  return itemAvailabilityComposable.getBackgroundClass();
};

const getItemAvailabilityTextClass = (
  itemDetails: BlackDesertItemDetails,
  itemAvailability: BlackDesertItemDetailsAvailability,
): string => {
  const itemAvailabilityComposable: UseItemAvailabilityReturn = useItemAvailability(itemDetails, itemAvailability);
  return itemAvailabilityComposable.getTextClass();
};

if (!itemType.value) {
  itemListFetch.fetchByEnhancement(props.enhancement).then((data: BlackDesertItemType | null): void => {
    itemType.value = data;
  });
}

if (!itemDetails.value) {
  itemDetailsFetch.fetch().then((data: BlackDesertItemDetails | null): void => {
    itemDetails.value = data;
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ItemDetailsTab, {
        id: 0,
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
        label: _unref(translate)('itemDetails.detailsTab')
      }, null, 8, ["modelValue", "label"]),
      _createVNode(ItemDetailsTab, {
        id: 1,
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event)),
        label: _unref(translate)('itemDetails.additionalTab')
      }, null, 8, ["modelValue", "label"]),
      _createVNode(ItemDetailsTab, {
        id: 2,
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeTab).value = $event)),
        label: _unref(translate)('itemDetails.availabilityTab')
      }, null, 8, ["modelValue", "label"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({
      'flex flex-col overflow-y-auto xl:w-2/3': true,
      'h-full': activeTab.value !== 2,
    })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass({
        'item-details': true,
        'hidden xl:block': activeTab.value !== 0,
      })
      }, [
        (itemType.value && itemDetails.value)
          ? (_openBlock(), _createBlock(ItemDetailsOverview, {
              key: 0,
              "item-type": itemType.value,
              "item-details": itemDetails.value
            }, null, 8, ["item-type", "item-details"]))
          : (_openBlock(), _createBlock(AppLoader, {
              key: 1,
              size: _unref(LoaderSize).LARGE
            }, null, 8, ["size"]))
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass({
        'item-details-additional': true,
        'hidden xl:block': activeTab.value !== 1,
      })
      }, [
        _createVNode(ItemDetailsAdditional)
      ], 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass({
      'item-details-availability': true,
      'hidden xl:block': activeTab.value !== 2,
    })
    }, [
      (itemDetails.value)
        ? (_openBlock(), _createBlock(ItemDetailsAvailability, { key: 0 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemDetails.value.availability, (item) => {
                return (_openBlock(), _createBlock(ItemDetailsAvailabilityItem, {
                  key: item.onePrice,
                  class: _normalizeClass(getItemAvailabilityBackgroundClass(itemDetails.value, item))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(getSellCount(itemDetails.value, item)), 1),
                    _createElementVNode("span", {
                      class: _normalizeClass([getItemAvailabilityTextClass(itemDetails.value, item), "w-full text-center"])
                    }, _toDisplayString(getOnePrice(itemDetails.value, item)), 3),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(getBuyCount(itemDetails.value, item)), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128))
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(AppLoader, {
            key: 1,
            size: _unref(LoaderSize).LARGE
          }, null, 8, ["size"]))
    ], 2)
  ], 64))
}
}

})